import { render, staticRenderFns } from "./VModalLupa.vue?vue&type=template&id=7c31bcdb&scoped=true&"
import script from "./VModalLupa.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VModalLupa.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./VModalLupa.vue?vue&type=style&index=0&id=7c31bcdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c31bcdb",
  null
  
)

export default component.exports